import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { FeedEntryCard } from '@/components/discovery/feed-entry'
import { useMyFeed } from '@/features/discovery/use-feed'

const PAGE_SIZE = 20

/**
 * Phase 14 — replacement for the old `<SubscriptionsTabContent>`. Recency-DESC feed of recent
 * publishes from creators the user subscribes to.
 */
export const FeedTabContent = () => {
  const [page, setPage] = useState(0)
  const { data, isLoading, isError } = useMyFeed(page, PAGE_SIZE)

  if (isLoading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
    )
  }

  if (isError) {
    return <p className="text-destructive">Failed to load feed.</p>
  }

  if (!data || data.items.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <p className="text-sm text-muted-foreground">
            No publishes from your Subscriptions yet. When creators you follow publish a project,
            it&apos;ll appear here.{' '}
            <Link to="/browse" className="underline">
              Browse creators →
            </Link>
          </p>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="space-y-3">
      {data.items.map((entry) => (
        <FeedEntryCard key={entry.publishId} entry={entry} />
      ))}
      {data.totalPages > 1 && (
        <div className="flex items-center justify-between pt-2">
          <Button
            variant="outline"
            size="sm"
            disabled={page === 0}
            onClick={() => setPage((p) => Math.max(0, p - 1))}
          >
            Previous
          </Button>
          <span className="text-xs text-muted-foreground">
            Page {data.page + 1} of {data.totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={page + 1 >= data.totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  )
}
